import { useState } from "react";

export function useLoginForm(initialUsername = "", initialPassword = "") {
  const [username, setUsername] = useState(initialUsername);
  const [password, setPassword] = useState(initialPassword);
  const [showPassword, setShowPassword] = useState(false);
  const [emailError, setEmailError] = useState<string | null>(null);
  const [passwordError, setPasswordError] = useState<string | null>(null);

  const handleUsernameChange = (val: string) => {
    setUsername(val);
    if (!val) {
      setEmailError("Enter a valid email address.");
    } else {
      setEmailError(null);
    }
  };

  const handlePasswordChange = (val: string) => {
    setPassword(val);
    if (!val) {
      setPasswordError("Password is required.");
    } else {
      setPasswordError(null);
    }
  };

  const clearPassword = () => {
    setPassword("");
    setPasswordError(null);
  };

  return {
    username,
    setUsername: handleUsernameChange,
    password,
    setPassword: handlePasswordChange,
    clearPassword,
    showPassword,
    setShowPassword,
    emailError,
    passwordError,
  };
}
